// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PaymentProcessorForm from '../../ui/components/Forms/Payments/PaymentProcessor';

type Props = {
    isProcessing: boolean,
    isFailed: boolean,
    isSuccessfull: boolean,
};

class PaymentProcessor extends Component<Props> {
    shouldComponentUpdate(nextProps) {
        return (
            this.props.isProcessing !== nextProps.isProcessing ||
            this.props.isFailed !== nextProps.isFailed ||
            this.props.isSuccessfull !== nextProps.isSuccessfull
        );
    }

    render() {
        return (
            <span>
                {this.props.isFailed}
                {this.props.isProcessing}
                {this.props.isSuccessfull}
                <PaymentProcessorForm
                    isProcessing={this.props.isProcessing}
                    isFailed={this.props.isFailed}
                    isSuccessfull={this.props.isSuccessfull}
                />
            </span>
        );
    }
}

const mapStateToProps = (state: Object) => {
    return {
        isProcessing: state.payments.isProcessing,
        isFailed: state.notifications.isPaymentFailed,
        isSuccessfull: state.notifications.isPaymentSuccessfull,
    };
};

export default connect(
    mapStateToProps,
    null
)(PaymentProcessor);



// WEBPACK FOOTER //
// ./src/containers/Forms/PaymentProcessor.js